import React from 'react';
import { IniciarSesion } from '../components/IniciarSesion';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const InicioSesion = () => {
    return (
        <>
            <Header />
            <br></br>
            <br></br>
            <IniciarSesion />
            <div>
                <img style={{ width: '100%', maxWidth: '100%' }} src={process.env.REACT_APP_SERVER_IMAGE + 'estaticas/medios-pago.webp'} alt="medios de pago" />
            </div>
            <Footer />
        </>
    )
}

export { InicioSesion }